// extracted by mini-css-extract-plugin
export default {"footer":"yiUcoYOUDL7nF50gRD_U","noTopBorder":"UYBEHdKgSQ9JKOqBUgkn","collapsedFooter":"aZicNquEFFJLbscMvSyG","footerCTAs":"EVYiPz7or79K3puqRoJX"};